module.exports = __webpack_public_path__ + "static/media/22ESCWA2.4f6e41eb.jpg";